<script setup>
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
</script>

<template>
    <div v-if="store.getters.settings.enable_ai_search" class="ai-chat__tabs ai-chat__tabs--light">
        <b-nav tabs>
            <b-nav-item to="/search" class="tabs-discovery">
                Discovery (Beta)
            </b-nav-item>

            <b-nav-item to="/startups" class="tabs-manual">
                Manual Mode
            </b-nav-item>

            <b-nav-item to="/ecosystems" class="tabs-ecosystems">
                Ecosystems
            </b-nav-item>
        </b-nav>
    </div>
</template>

<style scoped>

</style>
